var $d407ef890ef1f9b8$exports = {};
/**
 * imagePopup.js
 *
 * - モバイル版のサービスフローセクションにある、Before・Afterの拡大ポップアップの開閉ロジック
 */ // ポップアップの要素を取得
const $d407ef890ef1f9b8$var$beforePatternPopup = document.getElementById("before-pattern-popup");
const $d407ef890ef1f9b8$var$afterPatternPopup = document.getElementById("after-pattern-popup");
// 開くボタンの要素を取得
const $d407ef890ef1f9b8$var$beforePatternButton = document.getElementById("before-pattern-button");
const $d407ef890ef1f9b8$var$afterPatternButton = document.getElementById("after-pattern-button");
// 閉じるボタンの要素を取得
const $d407ef890ef1f9b8$var$closeButtons = document.querySelectorAll(".c-image-popup__close-button ");
// ポップアップを開く処理
const $d407ef890ef1f9b8$var$showPopup = (pattern)=>{
    // スクロールを禁止
    document.body.style.overflowY = "hidden";
    if (pattern === "before") $d407ef890ef1f9b8$var$beforePatternPopup.showModal();
    else if (pattern === "after") $d407ef890ef1f9b8$var$afterPatternPopup.showModal();
};
// ポップアップを閉じる処理
const $d407ef890ef1f9b8$var$closePopup = ()=>{
    // スクロールを許可
    document.body.style.overflowY = "scroll";
    $d407ef890ef1f9b8$var$beforePatternPopup.close();
    $d407ef890ef1f9b8$var$afterPatternPopup.close();
};
// イベントリスナー
$d407ef890ef1f9b8$var$closeButtons.forEach((closeButton)=>{
    closeButton.addEventListener("click", $d407ef890ef1f9b8$var$closePopup);
});
$d407ef890ef1f9b8$var$beforePatternButton.addEventListener("click", ()=>$d407ef890ef1f9b8$var$showPopup("before"));
$d407ef890ef1f9b8$var$afterPatternButton.addEventListener("click", ()=>$d407ef890ef1f9b8$var$showPopup("after"));


//# sourceMappingURL=index.3592698e.js.map
